import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../../api/request";
import { getPaginationUrl } from "../../utils/constants/GetPaginationURL";

const initialState = {
  loading: false,
  resData: {
    data: [],
    meta: {},
  },
  sogoList: [],
  ogaList: [],
};

export const getOGMDashboardCounts = createAsyncThunk(
  "ogdDashboardSlice/getOGMDashboardCounts",
  async ({
    fromDate,
    toDate,
    sogoId,
    ogaIds,
    paginationData,
    selectedDateCriteria,
  }) => {
    let ogaFilter = "filters[userName]=equals:";
    if (ogaIds?.length > 0) {
      ogaFilter += ogaIds
        .map((name) => `${name}`)
        .join(encodeURIComponent("+"));
    }
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `analytics/assessment-counts${sogoId ? `/${sogoId}` : ""}${
        paginationData
          ? `${paginationUrl}&fromDate=${fromDate}&toDate=${toDate}`
          : `?fromDate=${fromDate}&toDate=${toDate}&limit=no`
      }${ogaIds?.length > 0 ? `&${ogaFilter}` : ""}&filterCriteria=${
        selectedDateCriteria?.id
      }`,
    });
    return res;
  }
);

export const getEmployeesDirectUnder = createAsyncThunk(
  "ogdDashboardSlice/getEmployeesDirectUnder",
  async () => {
    const res = await apiRequest({
      method: "get",
      url: `users/all-users-under/direct/null`,
    });
    return res;
  }
);

export const getOgaLists = createAsyncThunk(
  "ogdDashboardSlice/getOgaLists",
  async (sogoId) => {
    const res = await apiRequest({
      method: "get",
      url: `users/all-users-under/${sogoId}`,
    });
    return res;
  }
);

export const getOGADoneAssessments = createAsyncThunk(
  "ogdDashboardSlice/getOGADoneAssessments",
  async (dispatchParams) => {
    const {
      paginationData,
      ogaIdParams,
      fromDate,
      toDate,
      selectedDateCriteria,
    } = dispatchParams;
    const paginationUrl = getPaginationUrl(paginationData);
    const res = await apiRequest({
      method: "get",
      url: `lead/getLeadsDetails/${
        ogaIdParams ? ogaIdParams : ""
      }${paginationUrl}${fromDate ? `&fromDate=${fromDate}` : ""}${
        toDate ? `&toDate=${toDate}` : ""
      }&filterCriteria=${selectedDateCriteria?.id}`,
    });
    return res;
  }
);

const ogdDashboardSlice = createSlice({
  name: "ogdDashboardSlice",
  initialState,
  reducers: {
    clearData: (state) => {
      state.resData = {
        data: [],
        meta: {},
      };
    },
  },
  extraReducers: (builder) => {
    //..................GETING ALL OGM DASHBOARD COUNTS................
    builder.addCase(getOGMDashboardCounts.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getOGMDashboardCounts.fulfilled, (state, action) => {
      state.loading = false;
      state.resData = {
        data: action?.payload?.data || [],
        meta: action?.payload?.meta || {},
      };
    });
    // ------------------GETTING ALL  UNDER Employees Direct UNDER----------------------------------------
    builder.addCase(getEmployeesDirectUnder.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getEmployeesDirectUnder.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        sogoList: action.payload?.data,
      };
    });

    // ------------------GETTING ALL  UNDER OGA UNDER SOGO----------------------------------------
    builder.addCase(getOgaLists.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getOgaLists.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        ogaList: action.payload?.data,
      };
    });

    //..................GETING ALL OGA DONE ASSESSMENTS................
    builder.addCase(getOGADoneAssessments.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });

    builder.addCase(getOGADoneAssessments.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        resData: {
          ...state.resData,
          data: action?.payload?.data,
          meta: action?.payload?.meta,
        },
      };
    });
  },
});

export const { clearData } = ogdDashboardSlice.actions;
export default ogdDashboardSlice.reducer;
